/* HOP: "old map" touches on the world map (client trial, 2026-10-15):
   a faint graticule every 20 degrees, a dashed equator and tropics under the
   land, ocean names in spaced italic serif, a small compass rose, and city
   names that come in as the map is zoomed. All of it lives inside the map's
   pan/zoom group, so it moves with the map, and none of it takes the
   pointer, so hover and clicks on countries are as before.

   assets/map-geo.json carries no projection, only drawn paths. The paths
   are Natural Earth I; scale and offsets below were fitted to country
   bounds in that file (Iceland, South Africa, Australia, Greenland,
   Ecuador: under 1 unit off on a 1000-wide map). */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var R = Math.PI / 180;
  var S = 196.887, CX = 467.2, TY = 271.473;

  function raw(l, p) {
    var p2 = p * p, p4 = p2 * p2;
    return [
      l * (0.8707 - 0.131979 * p2 + p4 * (-0.013791 + p4 * (0.003971 * p2 - 0.001529 * p4))),
      p * (1.007226 + p2 * (0.015085 + p4 * (-0.044475 + 0.028874 * p2 - 0.005916 * p4))),
    ];
  }
  function P(lon, lat) {
    var r = raw(lon * R, lat * R);
    return [CX + S * r[0], TY - S * r[1]];
  }
  function line(pts) {
    return 'M' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' ');
  }
  function parallel(lat) {
    var pts = [];
    for (var lon = -180; lon <= 180; lon += 5) pts.push(P(lon, lat));
    return line(pts);
  }
  function el(name, cls, attrs) {
    var e = document.createElementNS(NS, name);
    if (cls) e.setAttribute('class', cls);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    return e;
  }

  // [name, lon, lat, tier]. Europe: up to three best-known cities a
  // country; Asia and Africa: one or two; the US: twenty holiday cities.
  var CITIES = [["New York",-74.006,40.713,1],["Los Angeles",-118.244,34.052,1],["Miami",-80.192,25.762,1],["San Francisco",-122.419,37.775,1],["Las Vegas",-115.14,36.17,2],["Orlando",-81.379,28.538,2],["Chicago",-87.63,41.878,2],["Honolulu",-157.858,21.307,2],["Washington, D.C.",-77.037,38.907,2],["New Orleans",-90.072,29.951,2],["Boston",-71.059,42.36,2],["Seattle",-122.332,47.606,2],["San Diego",-117.161,32.716,3],["Nashville",-86.781,36.163,3],["Austin",-97.743,30.267,3],["Charleston",-79.931,32.777,3],["Savannah",-81.099,32.081,3],["Key West",-81.78,24.555,3],["Denver",-104.99,39.739,3],["San Antonio",-98.494,29.424,3],["Toronto",-79.383,43.653,2],["Vancouver",-123.121,49.283,2],["Montreal",-73.568,45.502,3],["Mexico City",-99.133,19.433,2],["Cancún",-86.851,21.161,2],["Tulum",-87.465,20.211,3],["Havana",-82.367,23.113,2],["Punta Cana",-68.372,18.582,3],["Montego Bay",-77.919,18.471,3],["San Juan",-66.106,18.466,3],["Nassau",-77.345,25.048,3],["San José",-84.091,9.928,3],["Guatemala City",-90.513,14.634,3],["Panama City",-79.519,8.982,3],["Rio de Janeiro",-43.173,-22.907,1],["São Paulo",-46.633,-23.551,2],["Salvador",-38.501,-12.977,3],["Buenos Aires",-58.382,-34.604,1],["Mendoza",-68.845,-32.889,3],["Santiago",-70.669,-33.449,2],["Lima",-77.043,-12.046,2],["Cusco",-71.968,-13.532,2],["Bogotá",-74.072,4.711,2],["Cartagena",-75.479,10.391,3],["Quito",-78.468,-0.18,3],["Montevideo",-56.165,-34.901,3],["La Paz",-68.15,-16.5,3],["Caracas",-66.904,10.481,3],["Asunción",-57.575,-25.264,3],["London",-0.128,51.507,1],["Edinburgh",-3.188,55.953,2],["Manchester",-2.242,53.481,3],["Dublin",-6.26,53.35,2],["Galway",-9.057,53.271,3],["Cork",-8.476,51.898,3],["Paris",2.352,48.857,1],["Nice",7.262,43.71,2],["Lyon",4.836,45.764,3],["Madrid",-3.704,40.417,2],["Barcelona",2.173,41.385,1],["Seville",-5.984,37.389,3],["Lisbon",-9.139,38.722,1],["Porto",-8.611,41.15,3],["Faro",-7.93,37.019,3],["Rome",12.496,41.903,1],["Venice",12.316,45.441,2],["Florence",11.256,43.77,3],["Berlin",13.405,52.52,1],["Munich",11.582,48.135,2],["Hamburg",9.993,53.551,3],["Amsterdam",4.904,52.368,1],["Rotterdam",4.479,51.924,4],["Brussels",4.352,50.847,2],["Bruges",3.225,51.209,3],["Zurich",8.541,47.377,2],["Geneva",6.143,46.204,3],["Zermatt",7.749,46.02,3],["Vienna",16.373,48.208,2],["Salzburg",13.055,47.809,4],["Innsbruck",11.404,47.269,4],["Prague",14.438,50.076,1],["Brno",16.607,49.195,3],["Warsaw",21.012,52.23,2],["Kraków",19.945,50.065,3],["Gdańsk",18.647,54.352,3],["Budapest",19.04,47.498,2],["Athens",23.728,37.984,1],["Santorini",25.432,36.393,2],["Thessaloniki",22.944,40.64,3],["Istanbul",28.978,41.008,1],["Cappadocia",34.83,38.643,2],["Dubrovnik",18.094,42.65,2],["Split",16.44,43.508,3],["Zagreb",15.982,45.815,3],["Copenhagen",12.568,55.676,2],["Aarhus",10.203,56.163,3],["Stockholm",18.069,59.329,2],["Gothenburg",11.975,57.709,3],["Oslo",10.752,59.913,2],["Bergen",5.322,60.391,3],["Tromsø",18.956,69.649,3],["Helsinki",24.938,60.17,2],["Rovaniemi",25.729,66.503,3],["Reykjavík",-21.943,64.147,2],["Moscow",37.617,55.756,1],["Saint Petersburg",30.336,59.934,2],["Kyiv",30.523,50.45,2],["Lviv",24.03,49.84,3],["Bucharest",26.103,44.427,3],["Sofia",23.322,42.698,3],["Belgrade",20.457,44.787,3],["Ljubljana",14.506,46.057,3],["Bratislava",17.107,48.148,4],["Tallinn",24.754,59.437,3],["Riga",24.105,56.95,3],["Vilnius",25.28,54.687,3],["Kotor",18.771,42.425,4],["Tirana",19.819,41.328,3],["Tokyo",139.692,35.69,1],["Kyoto",135.768,35.012,2],["Beijing",116.407,39.904,1],["Shanghai",121.474,31.23,2],["Hong Kong",114.169,22.319,2],["Seoul",126.978,37.567,1],["Busan",129.076,35.18,3],["Taipei",121.565,25.033,2],["Bangkok",100.502,13.756,1],["Phuket",98.392,7.88,2],["Hanoi",105.834,21.028,2],["Ho Chi Minh City",106.63,10.823,2],["Siem Reap",103.86,13.364,3],["Luang Prabang",102.135,19.886,3],["Yangon",96.196,16.866,3],["Kuala Lumpur",101.687,3.139,2],["Singapore",103.82,1.352,1],["Bali",115.189,-8.409,1],["Jakarta",106.846,-6.208,3],["Manila",120.984,14.6,2],["El Nido",119.402,11.196,3],["New Delhi",77.209,28.614,1],["Mumbai",72.878,19.076,2],["Colombo",79.861,6.927,3],["Kathmandu",85.324,27.717,2],["Malé",73.509,4.175,3],["Dubai",55.271,25.205,1],["Abu Dhabi",54.377,24.453,3],["Doha",51.531,25.286,3],["Riyadh",46.675,24.713,3],["Palestine",35.214,31.769,2],["Petra",35.444,30.329,3],["Amman",35.91,31.954,3],["Beirut",35.502,33.894,3],["Tehran",51.389,35.689,3],["Isfahan",51.668,32.654,3],["Tbilisi",44.793,41.716,3],["Yerevan",44.515,40.179,3],["Baku",49.867,40.409,3],["Samarkand",66.976,39.627,3],["Almaty",76.889,43.238,3],["Ulaanbaatar",106.918,47.886,3],["Lahore",74.358,31.52,3],["Dhaka",90.413,23.811,3],["Muscat",58.405,23.588,3],["Cairo",31.236,30.044,1],["Luxor",32.64,25.687,3],["Marrakech",-7.981,31.629,1],["Casablanca",-7.59,33.573,3],["Tunis",10.182,36.807,3],["Algiers",3.059,36.754,3],["Cape Town",18.424,-33.925,1],["Johannesburg",28.047,-26.204,3],["Nairobi",36.822,-1.292,2],["Zanzibar",39.198,-6.165,2],["Arusha",36.683,-3.387,3],["Lagos",3.379,6.524,2],["Accra",-0.187,5.604,3],["Dakar",-17.467,14.716,3],["Addis Ababa",38.757,9.005,3],["Windhoek",17.084,-22.56,3],["Victoria Falls",25.857,-17.932,3],["Antananarivo",47.508,-18.879,3],["Kigali",30.059,-1.944,3],["Kampala",32.582,0.348,3],["Sydney",151.209,-33.869,1],["Melbourne",144.963,-37.814,2],["Brisbane",153.026,-27.47,3],["Perth",115.861,-31.95,3],["Auckland",174.763,-36.848,2],["Queenstown",168.663,-45.031,3],["Nadi",177.416,-17.776,3]];

  // [first line, second line, lon, lat, size]
  var OCEANS = [
    ['Pacific', 'Ocean', -124, 10, 10],
    ['Atlantic', 'Ocean', -40, 30, 9],
    ['Atlantic', 'Ocean', -15, -25, 8],
    ['Indian', 'Ocean', 78, -22, 9],
    ['Pacific', 'Ocean', 152, 16, 8],
  ];

  // Countries drawn but never named (client, 2026-10-15): no tooltip, no
  // click, no search hit. The shape stays so the coastline is not torn.
  var UNNAMED = ['Israel'];

  function quiet(g) {
    g.querySelectorAll('path[data-name]').forEach(function (p) {
      if (UNNAMED.indexOf(p.getAttribute('data-name')) === -1) return;
      ['data-name', 'tabindex', 'role', 'aria-label'].forEach(function (a) { p.removeAttribute(a); });
      p.style.pointerEvents = 'none';
    });
    var box = g.ownerSVGElement.closest('[data-hop-map]').querySelector('[data-hop-map-suggestions]');
    if (!box) return;
    new MutationObserver(function () {
      box.querySelectorAll('.hop-map__sug').forEach(function (b) {
        var name = b.firstChild && b.firstChild.nodeType === 3 ? b.firstChild.nodeValue : '';
        if (UNNAMED.indexOf(name) > -1) b.remove();
      });
    }).observe(box, { childList: true });
  }

  function decorate(g) {
    if (g.querySelector('.hop-map__deco')) return;
    quiet(g);

    var back = el('g', 'hop-map__deco', { 'aria-hidden': 'true' });
    var grat = '';
    for (var lon = -180; lon <= 180; lon += 20) {
      var pts = [];
      for (var lat = -80; lat <= 85; lat += 2.5) pts.push(P(lon, lat));
      grat += line(pts);
    }
    for (var la = -60; la <= 80; la += 20) if (la) grat += parallel(la);
    back.appendChild(el('path', 'hop-map__graticule', { d: grat }));
    back.appendChild(el('path', 'hop-map__tropic', { d: parallel(23.44) + parallel(-23.44) }));
    back.appendChild(el('path', 'hop-map__equator', { d: parallel(0) }));
    g.insertBefore(back, g.firstChild);

    var front = el('g', 'hop-map__deco', { 'aria-hidden': 'true' });
    OCEANS.forEach(function (o) {
      var p = P(o[2], o[3]);
      var t = el('text', 'hop-map__ocean', { x: p[0].toFixed(1), y: p[1].toFixed(1), 'font-size': o[4] });
      [o[0], o[1]].forEach(function (w, i) {
        var s = el('tspan', null, { x: p[0].toFixed(1), dy: i ? (o[4] * 1.25).toFixed(1) : '0' });
        s.textContent = w;
        t.appendChild(s);
      });
      front.appendChild(t);
    });

    var c = P(-128, -30);
    var rose = el('g', 'hop-map__compass', { transform: 'translate(' + c[0].toFixed(1) + ' ' + c[1].toFixed(1) + ') scale(1.15)' });
    rose.innerHTML =
      '<circle r="15" class="hop-map__compass-ring"/>' +
      '<circle r="12" class="hop-map__compass-ring hop-map__compass-ring--fine"/>' +
      '<path d="M8 -8 L1.5 -1.5 M-8 8 L-1.5 1.5 M8 8 L1.5 1.5 M-8 -8 L-1.5 -1.5" class="hop-map__compass-tick"/>' +
      '<path d="M0 -19 L3 -3 L0 0 Z M0 19 L-3 3 L0 0 Z M19 0 L3 3 L0 0 Z M-19 0 L-3 -3 L0 0 Z" class="hop-map__compass-dark"/>' +
      '<path d="M0 -19 L-3 -3 L0 0 Z M0 19 L3 3 L0 0 Z M19 0 L3 -3 L0 0 Z M-19 0 L-3 3 L0 0 Z" class="hop-map__compass-light"/>' +
      '<text y="-22" class="hop-map__compass-n">N</text>';
    front.appendChild(rose);

    // Cities: hidden on the whole-world view, they come in as the map is
    // zoomed — the best-known first (tier 1), the rest deeper in; tier 4
    // is the few that sit on a neighbour's label until zoomed far in. Each one
    // is drawn at a fixed screen size (scaled by 1/zoom in the CSS), so a
    // label never balloons when zooming.
    var towns = el('g', 'hop-map__cities');
    CITIES.forEach(function (c) {
      var p = P(c[1], c[2]);
      var at = el('g', 'hop-map__city hop-map__city--t' + c[3], {
        transform: 'translate(' + p[0].toFixed(2) + ' ' + p[1].toFixed(2) + ')',
      });
      var inner = el('g', 'hop-map__city-in');
      inner.appendChild(el('circle', 'hop-map__city-dot', { r: '1.9' }));
      var t = el('text', 'hop-map__city-name', { x: '4.2', y: '3' });
      t.textContent = c[0];
      inner.appendChild(t);
      at.appendChild(inner);
      towns.appendChild(at);
    });
    front.appendChild(towns);
    g.appendChild(front);

    // world-map.js writes the zoom into the group's transform; mirror it as
    // a level class on the svg so the CSS can show each tier.
    var svg = g.ownerSVGElement;
    function level() {
      var m = /scale\(([\d.]+)\)/.exec(g.getAttribute('transform') || '');
      var k = m ? parseFloat(m[1]) : 1;
      svg.classList.toggle('hop-z1', k >= 1.8);
      svg.classList.toggle('hop-z2', k >= 3);
      svg.classList.toggle('hop-z3', k >= 5);
      svg.classList.toggle('hop-z4', k >= 8);
    }
    new MutationObserver(level).observe(g, { attributes: true, attributeFilter: ['transform'] });
    level();
  }

  function watch(root) {
    var g = root.querySelector('svg g');
    if (!g) return;
    if (g.querySelector('path[data-name]')) return decorate(g);
    var mo = new MutationObserver(function () {
      if (g.querySelector('path[data-name]')) {
        mo.disconnect();
        decorate(g);
      }
    });
    mo.observe(g, { childList: true });
  }

  function all(scope) {
    scope.querySelectorAll('[data-hop-map]').forEach(watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(document); });
  else all(document);
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
